import "./SessioFinalImage.css";

const SessioFinalImage = ({ sessioFinalImage, name, years }) => {
  return (
    <div className="sessio-final-image">
      <img src={sessioFinalImage} alt="Sessio Final Ponent" />
      <div className="sessio-final__text">
        <p className="sessio-final__text-name">{name}</p>
        <p className="sessio-final__text-years">{years}</p>
      </div>
    </div>
  );
};

export default SessioFinalImage;
